"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _nicbaseReducers = require("nicbase-reducers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var RtvProviderCell = function RtvProviderCell(_ref) {
  var cellData = _ref.cellData;

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var _cellData$tourProject = cellData.tourProjects,
      tourProjects = _cellData$tourProject === void 0 ? [] : _cellData$tourProject,
      _cellData$segmentProj = cellData.segmentProjects,
      segmentProjects = _cellData$segmentProj === void 0 ? [] : _cellData$segmentProj;

  var _usePortalSystemExcha = (0, _hooks.usePortalSystemExchangeProjects)(portalId),
      systemExchangeProjects = _usePortalSystemExcha.data;

  var projectNames = (0, _react.useMemo)(function () {
    return _toConsumableArray(new Set([].concat(_toConsumableArray(tourProjects), _toConsumableArray(segmentProjects)).map(function (project) {
      var _systemExchangeProjec;

      return systemExchangeProjects === null || systemExchangeProjects === void 0 ? void 0 : (_systemExchangeProjec = systemExchangeProjects.find(function (systemExchangeProject) {
        return systemExchangeProject.id.toString() === project.id;
      })) === null || _systemExchangeProjec === void 0 ? void 0 : _systemExchangeProjec.projectName;
    }).filter(function (name) {
      return name;
    })));
  }, [segmentProjects, systemExchangeProjects, tourProjects]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "space-y-1"
  }, projectNames.map(function (name) {
    return /*#__PURE__*/_react["default"].createElement("div", null, name);
  }));
};

RtvProviderCell.propTypes = {
  cellData: _propTypes["default"].shape({
    tourProjects: _propTypes["default"].shape({
      id: _propTypes["default"].string
    }),
    segmentProjects: _propTypes["default"].shape({
      id: _propTypes["default"].string
    })
  })
};
RtvProviderCell.defaultProps = {
  cellData: {}
};
var _default = RtvProviderCell;
exports["default"] = _default;